import React, { useState, useRef, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import FormInputField from 'src/components/common/formInputField';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store/reducers/state';
import Loader from 'src/components/loader';
import { customFilterOption } from 'src/components/utilities/utils';
import Select from 'react-select';
import { useVideosActions } from 'src/store/videos/actions';

const EditCredits = () => {
  const dispatch = useDispatch();
  const videoActions = useVideosActions(dispatch);
  const ref = useRef<HTMLButtonElement>(null);
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
    watch
  } = useForm();
  const {
    creditJurisdictions,
    creditTypes,
    creditAllocation,
    singleCreditAllocation,
    isCreditAllocationAdded
  } = useSelector((state: RootState) => {
    return {
      creditJurisdictions: state.videos.creditJurisdictions,
      creditTypes: state.videos.creditTypes,
      creditAllocation: state.videos.creditAllocation,
      singleCreditAllocation: state.videos.singleCreditAllocation,
      isCreditAllocationAdded: state.videos.isCreditAllocationAdded
    };
  });

  useEffect(() => {
    if (isCreditAllocationAdded) {
      if (ref.current) {
        ref.current.click();
        handleCloseClick();
      }
    }
  }, [isCreditAllocationAdded]);

  const onSubmit = (data: any) => {
    if (singleCreditAllocation) {
      const id: any = singleCreditAllocation.id;
      const payloadData = {
        id,
        updateData: [
          { op: 'replace', path: 'creditJurisdictionsId', value: data.creditJurisdictionsId.value },
          { op: 'replace', path: 'creditTypeId', value: data.creditTypeId.value },
          { op: 'replace', path: 'creditValue', value: data.creditValue },
          { op: 'replace', path: 'referenceId', value: data.referenceId }
        ]
      };
      videoActions.updateCreditAllocationsRequestRequest(payloadData);
    }
  };

  const handleCloseClick = () => {
    reset({
      creditValue: '',
      creditJurisdictionsId: '',
      creditTypeId: '',
      referenceId: ''
    });
  };
  useEffect(() => {
    if (singleCreditAllocation) {
      const payloadData = {
        creditJurisdictionsId: {
          value: singleCreditAllocation.creditJurisdictionsId
            ? singleCreditAllocation.creditJurisdictionsId
            : '',
          label: singleCreditAllocation.jurisdiction
            ? singleCreditAllocation.jurisdiction
            : 'Select...'
        },
        creditTypeId: {
          value: singleCreditAllocation.creditTypeId ? singleCreditAllocation.creditTypeId : '',
          label: singleCreditAllocation.creditType ? singleCreditAllocation.creditType : 'Select...'
        },
        creditValue: singleCreditAllocation.creditValue,
        referenceId: singleCreditAllocation.referenceId
      };
      reset(payloadData);
    }
  }, [singleCreditAllocation]);

  return (
    <div>
      <div
        className="modal fade"
        id="EditCredits"
        aria-labelledby="EditCreditsLabel"
        aria-hidden="true">
        <div className="modal-dialog relative w-auto pointer-events-none max-w-xl">
          <div className="modal-content">
            <div className="relative modal-header flex flex-shrink-0 items-center justify-between p-4 rounded-t-md">
              <h5
                className="text-xl font-semibold leading-normal text-center w-full"
                id="EditCreditsLabel">
                Update CE Credits
              </h5>

              <button
                onClick={() => handleCloseClick()}
                ref={ref}
                type="button"
                className="dismiss-btn"
                data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div className="modal-body relative py-4 px-10">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className={`form-group mb-3`}>
                  <label className="block text-sm font-medium mb-1">Credit Type</label>
                  {creditTypes && (
                    <Controller
                      render={({ field: { onChange, value }, fieldState: { error } }) => (
                        <Select
                          filterOption={customFilterOption}
                          options={creditTypes.map((item) => ({
                            value: item.id,
                            label: item.type
                          }))}
                          value={value}
                          id="creditTypeId"
                          className="w-full"
                          onChange={(val) => onChange(val)}
                          isLoading={!creditTypes.length}
                        />
                      )}
                      name="creditTypeId"
                      control={control}
                      rules={{ required: true }}
                    />
                  )}
                  {errors.creditType?.type === 'required' && (
                    <span className="text-red-500 text-xs">Required Field</span>
                  )}
                </div>

                <div className={`form-group mb-3`}>
                  <FormInputField
                    label={'Value'}
                    type={'text'}
                    fieldName={'creditValue'}
                    register={register}
                    errors={errors}
                    isRequired={false}
                  />
                </div>

                <div className={`form-group mb-3`}>
                  <label className="block text-sm font-medium mb-1">Jurisdiction</label>
                  {creditJurisdictions && (
                    <Controller
                      render={({ field: { onChange, value }, fieldState: { error } }) => (
                        <Select
                          filterOption={customFilterOption}
                          options={creditJurisdictions.map((item) => ({
                            value: item.id,
                            label: item.jurisdictionName
                          }))}
                          value={value}
                          id="creditJurisdictionsId"
                          className="w-full"
                          onChange={(val) => onChange(val)}
                          isLoading={!creditJurisdictions.length}
                        />
                      )}
                      name="creditJurisdictionsId"
                      control={control}
                      rules={{ required: true }}
                    />
                  )}
                  {errors.creditJurisdictions?.type === 'required' && (
                    <span className="text-red-500 text-xs">Required Field</span>
                  )}
                </div>

                <div className={`form-group mb-3`}>
                  <FormInputField
                    label={'Reference ID'}
                    type={'text'}
                    fieldName={'referenceId'}
                    register={register}
                    errors={errors}
                    isRequired={false}
                  />
                </div>

                <div className="modal-footer mt-5 flex flex-shrink-0 flex-wrap items-center justify-center px-4 pb-2 rounded-b-md">
                  <button
                    type="submit"
                    className="px-6 btn-primary w-auto whitespace-nowrap mr-2 ml-0 mt-0">
                    Save Changes
                  </button>
                  <button
                    onClick={() => handleCloseClick()}
                    type="button"
                    className="mx-0 px-6 btn-primary discard-btn w-auto whitespace-nowrap mt-0"
                    data-bs-dismiss="modal">
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditCredits;
